import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import RequireAuth from "@/components/RequireAuth";

import LandingPage from "@/pages/LandingPage";
import ConsultantLogin from "@/pages/ConsultantLogin";
import ConsultantRegister from "@/pages/ConsultantRegister";
import ConsultantDashboard from "@/pages/ConsultantDashboard";
import ConsultantSettings from "@/pages/ConsultantSettings";
import ConsultantNewPractice from "@/pages/ConsultantNewPractice";
import PracticeDetail from "@/pages/PracticeDetail";
import AdminOverview from "@/pages/AdminOverview";
import AdminConsultants from "@/pages/AdminConsultants";
import AdminSubscriptions from "@/pages/AdminSubscriptions";
import AdminSettings from "@/pages/AdminSettings";
import ClientLanding from "@/pages/ClientLanding";
import ClientOnboarding from "@/pages/ClientOnboarding";
import ClientReport from "@/pages/ClientReport";
import ClientSign from "@/pages/ClientSign";
import ClientPractices from "@/pages/ClientPractices";
import ClientProfile from "@/pages/ClientProfile";
import PracticeConfirmed from "@/pages/PracticeConfirmed";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import TermsOfService from "@/pages/TermsOfService";
import AITransparency from "@/pages/AITransparency";
import SubProcessors from "@/pages/SubProcessors";
import BillingPage from "@/pages/BillingPage";
import SSOCallback from "@/pages/SSOCallback";
import PricingPage from "@/pages/PricingPage";

import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          {/* Public */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/login" element={<ConsultantLogin />} />
          <Route path="/register-consultant" element={<ConsultantRegister />} />
          <Route path="/register" element={<Navigate to="/register-consultant" replace />} />
          <Route path="/admin/login" element={<Navigate to="/login" replace />} />

          {/* Client PWA */}
          <Route path="/c/:slug" element={<ClientLanding />} />
          <Route path="/c/:slug/onboarding" element={<ClientOnboarding />} />
          <Route path="/c/:slug/profile" element={<ClientProfile />} />
          <Route path="/c/:slug/report" element={<ClientReport />} />
          <Route path="/c/:slug/sign/:practiceId" element={<ClientSign />} />
          <Route path="/c/:slug/practices" element={<ClientPractices />} />
          <Route path="/practice/confirmed" element={<PracticeConfirmed />} />

          {/* Legal */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/termini" element={<TermsOfService />} />
          <Route path="/trasparenza-ai" element={<AITransparency />} />
          <Route path="/sub-processors" element={<SubProcessors />} />
          <Route path="/auth/sso/callback" element={<SSOCallback />} />

          {/* Consultant */}
          <Route path="/dashboard" element={<RequireAuth role="consultant"><ConsultantDashboard /></RequireAuth>} />
          <Route path="/dashboard/new" element={<RequireAuth role="consultant"><ConsultantNewPractice /></RequireAuth>} />
          <Route path="/dashboard/settings" element={<RequireAuth role="consultant"><ConsultantSettings /></RequireAuth>} />
          <Route path="/dashboard/billing" element={<RequireAuth role="consultant"><BillingPage /></RequireAuth>} />
          <Route path="/dashboard/practice/:id" element={<RequireAuth role="consultant"><PracticeDetail /></RequireAuth>} />

          {/* SuperAdmin */}
          <Route path="/admin" element={<RequireAuth role="superadmin"><AdminOverview /></RequireAuth>} />
          <Route path="/admin/consultants" element={<RequireAuth role="superadmin"><AdminConsultants /></RequireAuth>} />
          <Route path="/admin/subscriptions" element={<RequireAuth role="superadmin"><AdminSubscriptions /></RequireAuth>} />
          <Route path="/admin/settings" element={<RequireAuth role="superadmin"><AdminSettings /></RequireAuth>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
